module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/en-社会责任.cec99570.png";